import { LoaderCircle, RefreshCw } from "lucide-react";

export const SignupCaptcha = ({ captcha, refresh, setAnswer, busy }) => (
  <div data-testid="register-captcha" aria-busy={captcha.loading} className="rounded-xl bg-slate-50 border border-slate-200 px-4 py-3">
    <label htmlFor="register-captcha-input" className="text-xs font-bold uppercase tracking-wider text-slate-500">
      Prove you're human
    </label>
    <div className="mt-2 flex flex-wrap items-center gap-3">
      <span data-testid="register-captcha-prompt" role="status" className="flex-1 min-w-0 text-sm font-semibold text-slate-800">
        {captcha.loading ? "Loading human check…" : captcha.prompt || "Human check unavailable"}
      </span>
      <input id="register-captcha-input" data-testid="register-captcha-input" type="text" inputMode="numeric"
        pattern="[0-9]*" autoComplete="off" aria-label="Answer to the human check"
        aria-describedby="register-captcha-feedback" placeholder="?" value={captcha.answer}
        onChange={(e) => setAnswer(e.target.value)} disabled={busy || captcha.loading || !captcha.id}
        required maxLength={2}
        className="w-20 shrink-0 bg-white border border-slate-200 rounded-xl px-3 py-2.5 text-sm text-center font-bold focus:outline-none focus:ring-2 focus:ring-emerald-500/40 disabled:opacity-50" />
    </div>
    <div id="register-captcha-feedback" data-testid="register-captcha-feedback">
      {captcha.error && <p data-testid="register-captcha-error" role="alert" className="mt-2 text-xs leading-relaxed text-red-700">{captcha.error}</p>}
      {!captcha.error && captcha.notice && <p data-testid="register-captcha-notice" role="status" className="mt-2 text-xs leading-relaxed text-slate-600">{captcha.notice}</p>}
    </div>
    <button type="button" data-testid="register-captcha-retry" onClick={() => refresh()}
      disabled={busy || captcha.loading}
      className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-700 hover:text-emerald-900 disabled:opacity-60 transition-colors">
      {captcha.loading ? <LoaderCircle size={13} className="animate-spin" aria-hidden="true" /> : <RefreshCw size={13} aria-hidden="true" />}
      {captcha.loading ? "Loading…" : captcha.error ? "Try again" : "New question"}
    </button>
  </div>
);